



























import { previewBaseUrl } from "@/.config";
import { expandCloudinary, expandPath } from "@/api/helpers";
import { hasCloudinaryPath, notEmptyString } from "@/api/validators";
import { SimpleProject, SiteState } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export default class LinkSet extends Vue {
  @Prop({ default: "project" }) project: SimpleProject;
  @State("site") site: SiteState;

  get hasProject() { 
    return this.project instanceof Object && this.project.exists && notEmptyString(this.project.groupName);
  }

  get projectMembers() {
    return this.hasProject && this.project.members instanceof Array ? this.project.members.map(m => {
      const itemKey = ['members', m.identifier].join('-');
      const mailto = ['mailto', m.identifier].join(':');
      return { ...m, itemKey, mailto };
    }) : [];
  }

  get hasDefaultImage(): boolean {
    return notEmptyString(this.project.imageUri, 9)
  }

  get filePath(): string {
    return this.hasDefaultImage ? hasCloudinaryPath(this.project.imageUri) ? expandCloudinary(this.project.imageUri, "thumb") : expandPath(this.project.imageUri, "thumb") : "";
  }

  get altRef(): string {
    return this.project.groupName;
  }

  get hasTheme(): boolean {
    return this.project.themeTree instanceof Object && notEmptyString(this.project.themeTree.text);
  }

  get themeText(): string {
    return this.project.themeTree.text;
  }

  get subthemeList(): string {
    return this.project.themeTree.children.map(ch => ch.text).join(', ');
  }

  get projectUrl() {
    const base = this.site.settings.get('preview_base_url');
    const baseUrl = notEmptyString(base, 8)? base : previewBaseUrl;
    return [baseUrl.replace('/students', '/projects'), this.project.slug].join('/');
  }

  get projectPreviewHint() {
    return this.site.label('project_preview_hint');
  }
}
